import { Flex } from 'components/flex';
import { CloverReceiptType } from 'types';
import { Config, AppRoutes } from 'config';
import { Button } from 'components/button';
import { InfoBlock } from 'components/info-block';
import { TotalCart } from 'components/total-cart';
import { joinRoutes, formatPrice } from 'utils/helpers';
import { isMobile, useSelectedCloverDevice } from 'hooks';
import { SendReceiptDialog } from 'components/send-receipt-dialog';
import { ProductSummaryList } from 'components/product-summary-list';
import { PrintReceiptFromTerminalButton } from 'components/print-receipt-from-terminal-button';

import { ExchangeDetailsProps } from './types';

const { Home, Receipts } = AppRoutes.Products;

export const ExchangeDetails = ({ data }: ExchangeDetailsProps) => {
  const mobile = isMobile();

  const { deviceOptions, selectedDeviceId: deviceId } = useSelectedCloverDevice(
    data?.event
  );

  if (!data?.exchanges?.length) {
    return null;
  }

  return data?.exchanges?.map((value) => {
    const itemsWithoutExchange = value?.items?.filter(
      (item) => !item.isExchange
    );

    return (
      <InfoBlock key={value.id} title={`Exchange #${value.id}`}>
        <Flex column gap={24}>
          <Flex column gap={8}>
            <p>
              <b>Total Exchange Amount:</b>{' '}
              {formatPrice(value.exchangeItemsAmount)}
            </p>

            <p>
              <b>Total Replacement Amount:</b>{' '}
              {formatPrice(
                itemsWithoutExchange?.reduce(
                  (acc, item) => acc + +item.price * item.quantity,
                  0
                )
              )}
            </p>
          </Flex>

          <ProductSummaryList
            isExchange
            title="Return Products:"
            values={value?.items?.filter((item) => item.isExchange)}
          />

          <ProductSummaryList
            title="Exchange Products:"
            values={itemsWithoutExchange}
          />

          <TotalCart
            data={value}
            tip={value?.tip}
            eventTax={value?.tax}
            paymentMethods={value.paymentMethods}
            companyProcessingFees={value?.processingFees}
            shippingPrice={Number(value?.shippingPrice || 0)}
            isProcessingFeeEnabled={value?.isProcessingFeeEnabled}
          />

          <Flex gap={16} column={mobile}>
            <SendReceiptDialog data={value} />

            <PrintReceiptFromTerminalButton
              deviceId={deviceId}
              checkoutId={value?.id}
              pdfUrl={value?.pdfUrl}
              deviceOptions={deviceOptions}
              type={CloverReceiptType.Payment}
            />

            {Config.isDebugHTMLEnabled && (
              <Button
                text="View HTML"
                to={joinRoutes(
                  [Home, Receipts.Home, Receipts.Details, Receipts.HTML],
                  {
                    id: data.eventId,
                    receiptId: value.id,
                  }
                )}
              />
            )}
          </Flex>
        </Flex>
      </InfoBlock>
    );
  });
};
